import { DefineComponentProps } from 'utils'
import type { HTMLAttributes } from 'vue'

type CloseIconProps = HTMLAttributes & {
  fill?: string
}

export const CloseIcon = defineComponent<CloseIconProps>({
  props: DefineComponentProps<CloseIconProps>(['onClick', 'fill']),
  setup(props) {
    return () => (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M9.08388 8L14.7842 2.2973C15.0719 2.00945 15.0719 1.53487 14.7842 1.24701L14.7531 1.21589C14.4654 0.928036 13.991 0.928036 13.7032 1.21589L8.00292 6.92637L2.3026 1.21589C2.01486 0.928036 1.54048 0.928036 1.25274 1.21589L1.22164 1.24701C0.926121 1.53487 0.926121 2.00945 1.22164 2.2973L6.92196 8L1.22164 13.7027C0.933898 13.9906 0.933898 14.4651 1.22164 14.753L1.25274 14.7841C1.54048 15.072 2.01486 15.072 2.3026 14.7841L8.00292 9.08141L13.7032 14.7841C13.991 15.072 14.4654 15.072 14.7531 14.7841L14.7842 14.753C15.0719 14.4651 15.0719 13.9906 14.7842 13.7027L9.08388 8Z"
          fill={props.fill || 'var(--colors-text-base)'}
        />
      </svg>
    )
  },
})

export const CloseSimpleIcon = defineComponent<HTMLAttributes>({
  props: DefineComponentProps<HTMLAttributes>(['onClick']),
  setup(props) {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
        <path
          d="M3.70218 3.70798L10.3018 10.3076M3.70218 10.3076L10.3018 3.70798"
          stroke="var(--colors-bg-icon-secondary)"
          stroke-width="0.933333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    )
  },
})
